import React, { useState, useEffect, Fragment } from 'react'
import { useStore } from '@nanostores/react'
import { cartData } from '@stores/cartStore'
import { convertToCurrency } from '../../utils/utils'

import FreeProduct from './FreeProduct.jsx'

const ShippingRemainder = () => {
    let $cartData = useStore(cartData || null)

    const [data, setData] = useState({})

    const [showDetails, setShowDetails] = useState(false)

    let freeProduct

    useEffect(() => {
        if ($cartData) {
            let $newCartData = cartData.get()
            //

            const invalidProductTypes = [
                'Gift Cards',
                'Gift Card',
                'Specialty SKU',
                'Embroidery Option',
                'Embroidery',
                'Virtual Classes',
                'Classes + Events',
                'Nursery',
                'Cribs',
                'Classes',
                'Strollers',
            ]

            const lines = $newCartData?.lines || null

            let applicableLines

            // get applicable items subtotal
            if (lines && lines.length > 0) {
                applicableLines = lines.filter((line) => {
                    const item = line.node
                    const productType = item?.merchandise?.product?.productType
                    const vendor = item?.merchandise?.product?.vendor
                    return (
                        !invalidProductTypes.includes(productType) &&
                        vendor === 'Monica + Andy'
                    )
                })
            }

            //

            let subTotal
            let subtotal
            let shippingRemainder

            if (applicableLines && applicableLines.length > 0) {
                subtotal = applicableLines.reduce(function (
                    previousValue,
                    currentValue
                ) {
                    //
                    return (
                        parseFloat(previousValue) +
                        parseFloat(currentValue.node.cost.totalAmount.amount)
                    )
                },
                0)
            }

            if (subtotal) {
                subTotal = parseFloat(subtotal).toFixed(2) || 0
                shippingRemainder = parseFloat(75 - subTotal).toFixed(2) || 0
                freeProduct = parseFloat(75 - subTotal).toFixed(2) || 0
            }

            //

            setData({
                ...$newCartData,
                subTotal: subTotal,
                shippingRemainder: shippingRemainder,
                freeProduct: freeProduct,
            })
        }
    }, [$cartData])

    return (
        <>
            <div
                className={`shipping-info ${
                    data && data.subTotal >= 75
                        ? 'bg-fern/50 text-ash'
                        : 'bg-beige text-flint'
                }  font-normal text-sm flex items-center justify-center py-1`}
            >
                {/* {data && data.subTotal > 0 ? (
                    <span className='text-sm'>
                        FREE Standard Shipping on all orders!
                    </span>
                ) : (
                    <span className='text-sm'>
                        FREE Standard Shipping on all orders!
                    </span>
                )} */}
                {data &&
                data.subTotal > 0 &&
                data.subTotal < 75 &&
                data.shippingRemainder ? (
                    <span className="text-sm">
                        Spend{' '}
                        <span className="font-medium">
                            ${data.shippingRemainder}
                        </span>{' '}
                        more to get FREE Standard Shipping*
                    </span>
                ) : data.subTotal >= 75 ? (
                    <span className="text-sm">
                        You've qualified for FREE Standard Shipping!
                    </span>
                ) : (
                    <span className="text-sm">
                        FREE Standard Shipping for orders over $75*
                    </span>
                )}
            </div>
            <div className="free-shipping-details text-xs text-center font-normal">
                <span
                    className="cursor-pointer"
                    onClick={() => setShowDetails(!showDetails)}
                >
                    * {showDetails ? 'Hide ' : 'Show '}Details
                </span>
                {showDetails ? (
                    <div className="text-[10px] text-center font-normal px-4">
                        Based on elligible products in cart. Gift Cards,
                        embroidery, classes, digital products, and specialty
                        SKUs do not count towards the $75 free shipping
                        threshold. Free shipping applies to orders shipped
                        within the contiguous United States only. Other
                        restrictions apply.
                    </div>
                ) : null}
            </div>
            {/* {data ? (
                <div className="free-product">
                    <FreeProduct data={data} freeProduct={freeProduct} />
                </div>
            ) : null} */}
        </>
    )
}

export default ShippingRemainder
